<template>
    <div class="d-inline-flex align-center">
        <div v-if="tipoCompraDireta === 'COM_DISPUTA'" class="texto-alerta">
            <p class="mb-0">
                <strong>Atenção!</strong>
            </p>
            <p class="mb-0">
                As informações dos itens <br> preenchidos acima,
                após <br> enviados serão utilizados <br> como valor inicial
                na <br> etapa de lances.
            </p>
        </div>
        <div class="flex md6">
            <az-call-to-action id="botao-salvar-proposta" @click="$emit('click')" slot="actions"
                               css-class="botao-principal text-uppercase d-flex align-center">
                Enviar proposta
                <v-icon color="white">
                    keyboard_arrow_right
                </v-icon>
            </az-call-to-action>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BotaoEnviarProposta',
    props:{
        tipoCompraDireta:{
            type: String,
            default: null
        }
    }
}
</script>

<style scoped lang="stylus">
    .action-primary
        padding 10px 15px
        border 1px solid var(--v-primary-base)
        background-color var(--v-primary-base) !important
        color #fff !important
        margin-left 10px
        border-radius 2px

        i
            margin-right 0

    .texto-alerta
        color var(--v-error-base)
        margin-right 24px
        text-align right

    .botao-principal
        background-color var(--v-primary-base) !important
        color #fff !important
        padding 10px 15px
        border 1px solid var(--v-primary-base)
        border-radius 2px

        i
            margin-right 0
</style>
